/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductListSkuItem } from './ProductListSkuItem';
import {
    ProductListSkuItemFromJSON,
    ProductListSkuItemFromJSONTyped,
    ProductListSkuItemToJSON,
    ProductListSkuItemToJSONTyped,
} from './ProductListSkuItem';

/**
 * 
 * @export
 * @interface ProductListResVo
 */
export interface ProductListResVo {
    /**
     * SPU主键ID
     * @type {number}
     * @memberof ProductListResVo
     */
    spuId?: number;
    /**
     * SPU编码
     * @type {string}
     * @memberof ProductListResVo
     */
    spuCode?: string;
    /**
     * 会员名
     * @type {string}
     * @memberof ProductListResVo
     */
    userName?: string;
    /**
     * 用户编号
     * @type {string}
     * @memberof ProductListResVo
     */
    userCode?: string;
    /**
     * SPU图片URL
     * @type {string}
     * @memberof ProductListResVo
     */
    imageUrl?: string;
    /**
     * 商品名称
     * @type {string}
     * @memberof ProductListResVo
     */
    productName?: string;
    /**
     * 产地标签
     * @type {string}
     * @memberof ProductListResVo
     */
    originLabel?: string;
    /**
     * 是否年满14岁
     * @type {string}
     * @memberof ProductListResVo
     */
    underFourteenYearsOld?: string;
    /**
     * 有效期标识
     * @type {string}
     * @memberof ProductListResVo
     */
    validPeriod?: string;
    /**
     * 创建时间
     * @type {string}
     * @memberof ProductListResVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof ProductListResVo
     */
    updateTime?: string;
    /**
     * 是否可编辑（上架列表显示修改按钮）
     * @type {boolean}
     * @memberof ProductListResVo
     */
    editable?: boolean;
    /**
     * 是否可全部下架（上架列表显示）
     * @type {boolean}
     * @memberof ProductListResVo
     */
    canAllOffShelf?: boolean;
    /**
     * 是否可上架（下架列表显示）
     * @type {boolean}
     * @memberof ProductListResVo
     */
    canOnShelf?: boolean;
    /**
     * 是否可删除（与上下架状态无关）；false 表示该 SPU 下有 SKU 曾在订单中出现过，删除接口会拒绝
     * @type {boolean}
     * @memberof ProductListResVo
     */
    deletable?: boolean;
    /**
     * 
     * @type {Array<ProductListSkuItem>}
     * @memberof ProductListResVo
     */
    skus?: Array<ProductListSkuItem>;
}

/**
 * Check if a given object implements the ProductListResVo interface.
 */
export function instanceOfProductListResVo(value: object): value is ProductListResVo {
    return true;
}

export function ProductListResVoFromJSON(json: any): ProductListResVo {
    return ProductListResVoFromJSONTyped(json, false);
}

export function ProductListResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductListResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'spuId': json['spuId'] == null ? undefined : json['spuId'],
        'spuCode': json['spuCode'] == null ? undefined : json['spuCode'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'productName': json['productName'] == null ? undefined : json['productName'],
        'originLabel': json['originLabel'] == null ? undefined : json['originLabel'],
        'underFourteenYearsOld': json['underFourteenYearsOld'] == null ? undefined : json['underFourteenYearsOld'],
        'validPeriod': json['validPeriod'] == null ? undefined : json['validPeriod'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
        'editable': json['editable'] == null ? undefined : json['editable'],
        'canAllOffShelf': json['canAllOffShelf'] == null ? undefined : json['canAllOffShelf'],
        'canOnShelf': json['canOnShelf'] == null ? undefined : json['canOnShelf'],
        'deletable': json['deletable'] == null ? undefined : json['deletable'],
        'skus': json['skus'] == null ? undefined : ((json['skus'] as Array<any>).map(ProductListSkuItemFromJSON)),
    };
}

export function ProductListResVoToJSON(json: any): ProductListResVo {
    return ProductListResVoToJSONTyped(json, false);
}

export function ProductListResVoToJSONTyped(value?: ProductListResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'spuId': value['spuId'],
        'spuCode': value['spuCode'],
        'userName': value['userName'],
        'userCode': value['userCode'],
        'imageUrl': value['imageUrl'],
        'productName': value['productName'],
        'originLabel': value['originLabel'],
        'underFourteenYearsOld': value['underFourteenYearsOld'],
        'validPeriod': value['validPeriod'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
        'editable': value['editable'],
        'canAllOffShelf': value['canAllOffShelf'],
        'canOnShelf': value['canOnShelf'],
        'deletable': value['deletable'],
        'skus': value['skus'] == null ? undefined : ((value['skus'] as Array<any>).map(ProductListSkuItemToJSON)),
    };
}

